module.exports = __webpack_public_path__ + "assets/img/ico_psn.0620c2b2.svg";